import {NgModule} from '@angular/core';

import {UISvgIconComponent} from './svg-icon.component';
import {UISvgIconService} from './svg-icon.service';

@NgModule({
    declarations: [UISvgIconComponent],
    exports: [UISvgIconComponent],
    providers: [UISvgIconService]
})
export class UISvgIconModule {
}